import hCrud from './src/h-crud'

hCrud.install = function (Vue) {
  Vue.component(hCrud.name, hCrud);
};

export default hCrud;